export const fontWeights = {
  light: 300,
  normal: 400,
  'lighter-bold': 500,
  'light-bold': 600,
  bold: 700,
  bolder: 800,
  black: 900,
};
